import type { ReactNode } from 'react';

import { ExternalLink } from '@/shared/components/ExternalLink';
import { isWebAddress } from '@/shared/components/webAddress';

/** A name on the forge: a link when there is an address for it, else text. */
export function ForgeLink({
  href,
  className,
  children,
}: {
  href: string | null;
  className?: string;
  children: ReactNode;
}) {
  if (href && isWebAddress(href)) {
    return (
      <ExternalLink href={href} className={className}>
        {children}
      </ExternalLink>
    );
  }
  return <span className={className}>{children}</span>;
}
